module.exports = __webpack_public_path__ + "static/media/04.5ce7b4d1.jpg";